import { MDSDropdown } from '@marqvision/mds-v2';
import { useSmartRuleOptions } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const SmartRuleFilter = (props: ResponsiveProps) => {
  return <Filter {...props} />;
};

const Filter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const smartRules = useSmartRuleOptions();

  return (
    <MDSDropdown
      label="Smart rules"
      value={smartRules.selected}
      list={smartRules.list}
      isDisabled={smartRules.disabled}
      isLoading={smartRules.isFetching}
      onChange={(value) => smartRules.select(value)}
      modules={[
        'search',
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
